import { InjectionToken } from '@angular/core';
import { ICommonKeyValues } from '../../@types/core';

export interface ICommonAppData extends ICommonKeyValues {
	readonly locale: string;
	readonly appName: string;
	readonly appFullLocationUrl: string;
	readonly appStartNotificationText: string;
	readonly domainName: string;
	readonly colorsDictionarySysName: string | null;
	readonly supportContacts?: {
		Email: string;
		Phone: string;
		SupportEmail?: string;
	};
}
export type TLocalAppDataGetter = (locale: string, location: Location) => ICommonAppData;

export const LOCAL_APP_DATA_GETTER = new InjectionToken<TLocalAppDataGetter>('LOCAL_APP_DATA_GETTER');
